import { LAYOUTS, } from "@voltmoney/types";
import { WIDGET, } from "@voltmoney/schema";
import { ROUTE } from '../../routes';
import { horizontalStepperRepo } from "../../configs/utils";
import { ACTION } from "./types";
import { goBack, goToPhoto, goToSupportDoc } from "./actions";
import SharedPropsService from "../../SharedPropsService";
export const template = (height, stepper, isRetryAllowed, isFromJupiter) => {
    return {
        layout: {
            id: ROUTE.PHOTO_MISMATCH,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                { id: 'photoMismatch', type: WIDGET.PHOTO_MISMATCH }
            ]
        },
        datastore: {
            photoMismatch: {
                height: height,
                stepperData: stepper,
                goToPhotoAction: {
                    type: ACTION.GO_TO_PHOTO,
                    routeId: ROUTE.PHOTO_MISMATCH,
                    payload: {}
                },
                goToSupportDocAction: {
                    type: ACTION.GO_TO_SUPPORTING_DOC,
                    routeId: ROUTE.PHOTO_MISMATCH,
                    payload: {}
                },
                goBackAction: {
                    type: ACTION.BACK_BUTTON,
                    payload: {},
                    routeId: ROUTE.PHOTO_MISMATCH,
                },
                retryAllowed: isRetryAllowed,
                isFromJupiter: isFromJupiter
            }
        },
    };
};
export const photoMismatchMf = {
    onLoad: async ({ getHeight, network }) => {
        const stepper = await horizontalStepperRepo(network);
        const height = getHeight();
        const noOfRetries = await SharedPropsService.getNumberOfPhotoVerificationRetries();
        const user = await SharedPropsService.getUser();
        const lenderId = user?.linkedApplications[0]?.lenderAccountId;
        const isRetryAllowed = false;
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER";
        return Promise.resolve(template(height, stepper, isRetryAllowed, isFromJupiter));
    },
    actions: {
        [ACTION.GO_TO_PHOTO]: goToPhoto,
        [ACTION.GO_TO_SUPPORTING_DOC]: goToSupportDoc,
        [ACTION.BACK_BUTTON]: goBack,
    },
};
